import { NETWORK_NUMBER } from 'core/config';

// TODO user type
export const hasAccountConnected = (user: any): boolean =>
  user.ethAddress && user.ethAddress[0];

export const hasCorrectNetwork = (chainId: number): boolean =>
  !!chainId && chainId.toString() === NETWORK_NUMBER;

// TODO user type
export const hasCorrectAccount = (user: any, account: string): boolean =>
  user.ethAddress[0].toLowerCase() === account?.toLowerCase();

export const hasWarning = (stack: any, _id: any) =>
  stack.find(({ id }: { id: any }) => id === _id);
